export const getSpinnerShow = (state) => {
  return state.VNLoader.show || false
}

export const getSpinnerText = (state) => {
  return state.VNLoader.text || ''
}
